import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useClipStatementsPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canSee, canCreate, canUpdate, canDelete } = useMemo(
    () => ({
      canSee: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.VIEW_CLIP_STATEMENT]),
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CLIP_STATEMENT]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CLIP_STATEMENT]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_CLIP_STATEMENT]),
    }),
    [hasPlatformPermission]
  );

  return {
    canSee,
    canCreate,
    canUpdate,
    canDelete,
  };
};
